import { http } from './httpClient'
import type { ChangePlanRequest, ChangePlanResult, ChargeHistoryItem, Paginated, Subscription } from './types'

function normalizeSubscription(subscription: Subscription): Subscription {
  const allowTeamMembers =
    subscription.plan.allow_team_members ?? subscription.plan.allows_team ?? false
  return {
    ...subscription,
    plan: {
      ...subscription.plan,
      monthly_price_cents: subscription.plan.monthly_price_cents ?? subscription.plan.price_cents,
      allow_team_members: allowTeamMembers,
      allows_team: allowTeamMembers,
      max_history_per_project: subscription.plan.max_history_per_project ?? null,
    },
  }
}

const EXPAND_PLAN = { expand: 'plan' }

export const subscriptionApi = {
  get: (workspaceId: number) =>
    http
      .get<Subscription>(`/api/workspaces/${workspaceId}/subscription/`, { query: EXPAND_PLAN })
      .then(normalizeSubscription),

  changePlan: (workspaceId: number, body: ChangePlanRequest): Promise<ChangePlanResult> =>
    http
      .post<ChangePlanResult, ChangePlanRequest>(
        `/api/workspaces/${workspaceId}/subscription/change-plan/`,
        body,
        { query: EXPAND_PLAN },
      )
      .then((result) => ({
        checkout_url: result.checkout_url ?? null,
        pending_confirmation: result.pending_confirmation ?? false,
        subscription: normalizeSubscription(result.subscription),
      })),
  revertDowngrade: (workspaceId: number) =>
    http
      .post<Subscription>(
        `/api/workspaces/${workspaceId}/subscription/revert-downgrade/`,
        undefined,
        { query: EXPAND_PLAN },
      )
      .then(normalizeSubscription),
  cancel: (workspaceId: number) =>
    http
      .post<Subscription>(
        `/api/workspaces/${workspaceId}/subscription/cancel/`,
        undefined,
        { query: EXPAND_PLAN },
      )
      .then(normalizeSubscription),
  charges: (workspaceId: number, params: { limit: number; offset: number }) =>
    http.get<Paginated<ChargeHistoryItem>>(
      `/api/workspaces/${workspaceId}/subscription/charges/`,
      { query: params },
    ),
}
